<template>
  <div class="pageHeader">
    <div class="topBox">
      <img :src="logo" class="logo" @click="changeTitle(0)" />
      <div class="menu">
        <div class="nav-list">
          <div
            class="nav-list-div"
            :class="{ actDiv: activeNum == index }"
            v-for="(item, index) in menuList"
            :key="index"
            @click="changeTitle(index)"
          >
            {{ item.label }}
          </div>
        </div>
        <div class="nav-line">
          <div class="nav-line-box">
            <div
              class="nav-line-div"
              :style="{
                transform: 'translateX(' + translateX + 'px)',
              }"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="background"></div>
    <div class="banner" v-if="bannerShow">
      <img :src="bannerImg" />
      <span class="span1">{{ bannerText }}</span>
      <span class="span2">{{ bannerText2 }}</span>
    </div>
    <div class="whiteBgc" v-if="!bannerShow && title">
      {{ title }}
    </div>
    <div class="whiteBgc2" v-if="!bannerShow && !title">
      您的位置：<span class="homeSpan" @click="changeTitle(0)">首页</span
      >&nbsp;>&nbsp;<slot name="address"></slot>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/img/logo.png";
export default {
  name: "pageHeader",
  props: {
    actNum: Number,
    bannerImg: String,
    bannerText: String,
    bannerText2: String,
    bannerShow: {
      type: Boolean,
      default: true,
    },
    title: String,
    address: String,
  },
  data() {
    return {
      logo,
      menuList: [
        { label: "首页" },
        { label: "产品中心" },
        { label: "解决方案" },
        { label: "服务支持" },
        { label: "关于我们" },
        // { label: "联系我们" },
      ],
      translateX: null,
      activeNum: null,
    };
  },
  methods: {
    changeTitle(i) {
      this.setUnderLine(i);
      if (i == 0) {
        this.$router.push("/");
      } else if (i == 1) {
        this.$router.push("/productCenter");
      } else if (i == 2) {
        this.$router.push("/solution");
      } else if (i == 3) {
        this.$router.push("/serviceSupport");
      } else if (i == 4) {
        this.$router.push("/aboutUs");
      }else if(i == 5){
        this.$router.push("/contactUs")
      }
    },
    setUnderLine(index) {
      this.activeNum = index;
      const elements = document.querySelectorAll(".nav-list-div");
      // 获取边距
      const computedStyle = window.getComputedStyle(elements[0]);
      const marginDiv = computedStyle.marginRight.replace("px", "");
      // 修改下划线宽度
      document.querySelector(".nav-line-div").style.width =
        elements[index].offsetWidth + "px";
      let numX = 0;
      elements.forEach((item, i) => {
        if (index > i) {
          numX = numX + item.offsetWidth;
        }
      });
      this.translateX = numX + marginDiv * (index * 2 + 1);
    },
    handleResize() {
      // console.log(this.actNum);
      if (document.documentElement.clientWidth < 1280) {
        return;
      } else {
        this.setUnderLine(this.actNum);
      }
    },
  },
  mounted() {
    this.setUnderLine(this.actNum);
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.pageHeader {
  width: 100%;
  .topBox {
    position: fixed;
    top: 0;
    width: 100%;
    height: 90px;
    display: flex;
    justify-content: space-between;
    background-color: #004f6a;
    padding: 20px 188px 0 188px;
    box-sizing: border-box;
    z-index: 999;
    .logo {
      width: 220px;
      height: 48px;
      cursor: pointer;
    }
    .menu {
      margin-top: 15px;
      margin-right: -60px;
      .nav-list {
        // height: 100%;
        display: flex;
        align-items: center;
        &-div {
          margin: 0 60px;
          // line-height: 32px;
          cursor: pointer;
          font-size: 16px;
          color: #fff;
          position: relative;
        }
        &-div:before {
          content: "";
          position: absolute;
          left: 50%;
          // bottom: -2px;
          top: 53px;
          width: 0;
          height: 2px;
          background: #fff;
          transition: all 0.3s;
        }
        &-div:hover:before {
          width: 100%;
          left: 0;
          right: 0;
        }
        .actDiv:hover::before {
          width: 0;
        }
      }
      .nav-line {
        margin: 0 auto;
        margin-top: 32px;
        height: 2px;
        background: transparent;
        &-div {
          // width: 0px;
          height: 2px;
          transition-duration: 0.3s;
          background: #fff;
        }
      }
    }
  }
  .background {
    margin-top: 90px;
    background-color: #004f6a;
    width: 100%;
    height: 300px;
  }
  .banner {
    margin: 0 auto;
    width: 1544px;
    height: 400px;
    margin-top: -210px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .span1 {
      position: absolute;
      top: 174px;
      left: 72px;
      font-size: 24px;
      color: #fff;
      line-height: 30px;
    }
    .span2 {
      position: absolute;
      top: 205px;
      left: 85px;
      font-size: 36px;
      color: #fff;
      line-height: 42px;
    }
  }
  .whiteBgc {
    width: 1545px;
    height: 90px;
    margin: 0 auto;
    margin-top: -90px;
    background-color: #fff;
    font-size: 30px;
    text-align: center;
    line-height: 90px;
  }
  .whiteBgc2 {
    // width: 1545px;
    // padding: 0 188px;
    height: 90px;
    margin: 0 188px;
    margin-top: -90px;
    background-color: #fff;
    font-size: 15px;
    // text-align: center;
    // line-height: 90px;
    padding-left: 72px;
    display: flex;
    align-items: flex-end;
    .homeSpan {
      cursor: pointer;
    }
  }
}
</style>